(function(root, factory) {
  if (typeof exports === "object") {
    // CommonJS
    module.exports = exports = factory(
      require("crypto-js/core"),
      //require("crypto-js/x64-core"),
      //require("crypto-js/lib-typedarrays"),
      //require("crypto-js/enc-utf16"),
      require("crypto-js/enc-base64"),
      require("crypto-js/md5"),
      //require("crypto-js/sha1"),
      //require("crypto-js/sha256"),
      //require("crypto-js/sha224"),
      //require("crypto-js/sha512"),
      //require("crypto-js/sha384"),
      //require("crypto-js/sha3"),
      //require("crypto-js/ripemd160"),
      //require("crypto-js/hmac"),
      //require("crypto-js/pbkdf2"),
      //require("crypto-js/evpkdf"),
      //require("crypto-js/cipher-core"),
      //require("crypto-js/mode-cfb"),
      // require("crypto-js/mode-ctr"),
      //require("crypto-js/mode-ctr-gladman"),
      //require("crypto-js/mode-ofb"),
     // require("crypto-js/mode-ecb"),
      //require("crypto-js/pad-ansix923"),
      // require("crypto-js/pad-iso10126"),
      //require("crypto-js/pad-iso97971"),
      //require("crypto-js/pad-zeropadding"),
      //require("crypto-js/pad-nopadding"),
      // require("crypto-js/format-hex"),
      require("crypto-js/aes")
      //require("crypto-js/tripledes"),
      //require("crypto-js/rc4"),
      //require("crypto-js/rabbit"),
      //require("crypto-js/rabbit-legacy")
    );
  } else {
    // Global (browser)
    root.CryptoJS = factory(root.CryptoJS);
  }
})(this, function(CryptoJS) {
  return CryptoJS;
});
